import { useParams } from "react-router-dom";
import secondaryComponents from "../../../../../components/secondaryComponents";
import { StorefrontDetailsForm } from "../../../../../components/secondaryComponents/storefront/StorefrontDetailsForm";
import {
  useGetSelectedStorefrontProduct,
  useGetViewStorefrontDetail,
} from "../../../../../hooks/api/queries";

const UpdateStorefront = () => {
  const { menuId } = useParams();
  const { data: storefrontDetails, isLoading } =
    useGetViewStorefrontDetail(menuId);
  const { data: selectedStorefrontProduct = [], isLoading: isFetchingProduct } =
    useGetSelectedStorefrontProduct(menuId);

  return (
    <secondaryComponents.MetaSetter
      title={"Lumi Merchant | Inventory - Update Storefront"}
      description={"Update a Storefront"}
    >
      <secondaryComponents.LoaderHelper
        isLoading={isLoading || isFetchingProduct}
        classNames={"mt-5"}
      >
        <StorefrontDetailsForm
          isEditMode={true}
          storefrontDetails={storefrontDetails}
          selectedStorefrontProduct={selectedStorefrontProduct}
        />
      </secondaryComponents.LoaderHelper>
    </secondaryComponents.MetaSetter>
  );
};
export default UpdateStorefront;
